import { ThemeProvider } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { getGiftCardPoints } from '../../api/giftCard';
import Loader from '../../store/loader';
import { theme } from '../../utils/themeProvider';
import GenericModalV2 from '../GenericModalV2';

import styles from './GiftCardForm.module.scss';

export default function GiftCardForm() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [mainText, setMainText] = useState('');

  const required = 'Αυτό το πεδίο είναι υποχρεωτικό';
  const cardPattern = `Μη έγκυρη κάρτα ${process.env.displayName}`;

  const errorMessages = {
    card: {
      required,
      pattern: cardPattern,
    },
  };

  const { handleSubmit, control } = useForm({
    mode: 'onBlur',
  });

  async function getPoints(_data) {
    const cardInput = _data.card.replace(/[^\d\s]/, '');

    Loader.addEvent('GETTING_POINTS');
    const newInput = cardInput.trim();
    const { data, error } = await getGiftCardPoints(newInput);
    if (error) {
      setMainText('Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε αργότερα');
      Loader.removeEvent('GETTING_POINTS');
      return;
    }
    const {
      payload: { successful },
    } = data;
    if (!successful) {
      setErrorMsg('Δεν υπάρχει διαθέσιμο ποσό προς εξαργύρωση  στην κάρτα σας.');
      Loader.removeEvent('GETTING_POINTS');
      return;
    }
    const {
      payload: { giftcardBalance },
    } = data;
    setMainText(`To υπολοιπο της καρτας σας είναι: ${giftcardBalance} €.`);
    setErrorMsg('');
    setModalOpen(true);
    Loader.removeEvent('GETTING_POINTS');
  }

  return (
    <>
      <form action="" method="POST" className={styles.form} onSubmit={handleSubmit(getPoints)}>
        <p className={styles.text}>
          Κάρτα {process.env.displayName}
          <span className={styles.span}>*</span>
        </p>
        <ThemeProvider theme={theme}>
          <Controller
            control={control}
            name="card"
            defaultValue=""
            rules={{
              required: true,
            }}
            render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
              <TextField
                {...field}
                variant="outlined"
                onChange={onChange}
                fullWidth
                error={error !== undefined}
                helperText={error && errorMessages.card[error.type]}
                className={styles.formField}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                }}
              />
            )}
          />
        </ThemeProvider>

        <div className={styles.btnContainer}>
          <input className={styles.submitBTn} value="Δείτε το υπόλοιπο σας!" type="submit" />
        </div>
        {errorMsg && <p className={styles.errorMsg}>{errorMsg}</p>}
      </form>

      {isModalOpen && (
        <GenericModalV2
          mainText={mainText}
          isOpen={isModalOpen}
          onClickContinue={() => setModalOpen(false)}
          modalLabel="Info modal"
        />
      )}
    </>
  );
}
